import { render, staticRenderFns } from "./promo-hzmb-list.vue?vue&type=template&id=45528ecc&scoped=true&"
import script from "./promo-hzmb-list.vue?vue&type=script&lang=js&"
export * from "./promo-hzmb-list.vue?vue&type=script&lang=js&"
import style0 from "./promo-hzmb-list.vue?vue&type=style&index=0&id=45528ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45528ecc",
  null
  
)

export default component.exports